import DetailedCourseContainer from "../../../../Components/Miscellaneous/Learning/DetailedCourse/DetailedCourseContainer";

const CourseDetails = () => {
  return <DetailedCourseContainer />;
};

export default CourseDetails;
